/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './paramedic-referral.reducer';

export const ParamedicReferral = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const paramedicReferralList = useAppSelector(state => state.paramedicReferral.entities);
  const loading = useAppSelector(state => state.paramedicReferral.loading);
  const totalItems = useAppSelector(state => state.paramedicReferral.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="paramedic-referral-heading" data-cy="ParamedicReferralHeading">
        <Translate contentKey="tinyMedicRestApp.paramedicReferral.home.title">Paramedic Referrals</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.paramedicReferral.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/paramedic-referral/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.paramedicReferral.home.createLabel">Create new Paramedic Referral</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.paramedicReferral.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {paramedicReferralList && paramedicReferralList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('referralTypeCode')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.referralTypeCode">Referral Type Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralTypeCode')} />
                </th>
                <th className="hand" onClick={sort('referralName')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.referralName">Referral Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralName')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('served')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.served">Served</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('served')} />
                </th>
                <th className="hand" onClick={sort('referralNotes')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.referralNotes">Referral Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralNotes')} />
                </th>
                <th className="hand" onClick={sort('accepted')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.accepted">Accepted</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accepted')} />
                </th>
                <th className="hand" onClick={sort('rejected')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.rejected">Rejected</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rejected')} />
                </th>
                <th className="hand" onClick={sort('rejectNotes')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.rejectNotes">Reject Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rejectNotes')} />
                </th>
                <th className="hand" onClick={sort('patientType')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.patientType">Patient Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientType')} />
                </th>
                <th className="hand" onClick={sort('exposed')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.exposed">Exposed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exposed')} />
                </th>
                <th className="hand" onClick={sort('sourceAppointmentId')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.sourceAppointmentId">Source Appointment Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sourceAppointmentId')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.admission">Admission</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.referredTo">Referred To</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.referredAt">Referred At</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.referredBy">Referred By</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferral.glucoUser">Gluco User</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {paramedicReferralList.map((paramedicReferral, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/paramedic-referral/${paramedicReferral.id}`} color="link" size="sm">
                      {paramedicReferral.id}
                    </Button>
                  </td>
                  <td>{paramedicReferral.referralTypeCode}</td>
                  <td>{paramedicReferral.referralName}</td>
                  <td>{paramedicReferral.active ? 'true' : 'false'}</td>
                  <td>{paramedicReferral.timestampEntry}</td>
                  <td>{paramedicReferral.microSec}</td>
                  <td>{paramedicReferral.lastUpdated}</td>
                  <td>{paramedicReferral.cursor}</td>
                  <td>{paramedicReferral.served ? 'true' : 'false'}</td>
                  <td>{paramedicReferral.referralNotes}</td>
                  <td>{paramedicReferral.accepted ? 'true' : 'false'}</td>
                  <td>{paramedicReferral.rejected ? 'true' : 'false'}</td>
                  <td>{paramedicReferral.rejectNotes}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientType.${paramedicReferral.patientType}`} />
                  </td>
                  <td>{paramedicReferral.exposed ? 'true' : 'false'}</td>
                  <td>{paramedicReferral.sourceAppointmentId}</td>
                  <td>
                    {paramedicReferral.admission ? (
                      <Link to={`/admission/${paramedicReferral.admission.id}`}>{paramedicReferral.admission.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferral.referredTo ? (
                      <Link to={`/doctor/${paramedicReferral.referredTo.id}`}>{paramedicReferral.referredTo.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferral.referredAt ? (
                      <Link to={`/hospital/${paramedicReferral.referredAt.id}`}>{paramedicReferral.referredAt.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferral.referredBy ? (
                      <Link to={`/paramedic/${paramedicReferral.referredBy.id}`}>{paramedicReferral.referredBy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferral.glucoUser ? (
                      <Link to={`/gluco-user/${paramedicReferral.glucoUser.id}`}>{paramedicReferral.glucoUser.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/paramedic-referral/${paramedicReferral.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/paramedic-referral/${paramedicReferral.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/paramedic-referral/${paramedicReferral.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.home.notFound">No Paramedic Referrals found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={paramedicReferralList && paramedicReferralList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ParamedicReferral;
